import * as s from 'styled-components';
import { rem } from 'polished';
import { TextP } from '../../Defaults/Text';
import React from 'react';
const styled = s.default;

export const Table: any = styled.table`
  width: 100%;
  margin: 0;
  padding: 0;
  border-collapse: separate;
  border-spacing: 0 0;
`;

export interface TableColumn {
  align?: 'left' | 'center' | 'right';
}

export const TableTd: any = styled.td`
  text-align: ${(props: TableColumn) => props.align || 'left'};
`;

export const CellText: any = styled(TextP)`
  font-size: ${rem(14)};
  line-height: ${rem(22)};
  color: ${({ theme }) => theme.colors.textPrimary};
  font-weight: 300;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: color 0.2s;

  ${({ theme }) => theme.mediab.m580`
    font-size: ${rem(13)};
    line-height: ${rem(21)};
  `}
`;

export const TableTh: any = styled.th`
  text-align: ${(props: TableColumn) => props.align || 'left'};
  padding: 0 0 ${rem(16)};
  color: ${({ theme }) => theme.colors.textPrimary};
  font-size: ${rem(14)};
  line-height: ${rem(22)};
  font-weight: 400;
  border-bottom: ${({ theme }) => theme.borders.primary};
`;

export const SecondTableTh: any = styled(TableTh)<{
  width?: string;
  minWidth?: string;
}>`
  padding: ${rem(16)} ${rem(24)};
  border-bottom: 0;
  background-color: ${({ theme }) => theme.colors.navSecondary};
  color: ${({ theme }) => theme.colors.primary};
  width: ${({ width }) => (width ? width : '')};
  min-width: ${({ minWidth }) => (minWidth ? minWidth : 'initial')};
  white-space: nowrap;

  ${({ theme }) => theme.mediab.m580`
    font-size: ${rem(13)};
    line-height: ${rem(21)};
  `}
`;

export const BasicTableTh: any = styled(TableTh)<{
  width?: string;
  minWidth?: string;
}>`
  padding: ${rem(16)} 0;
  border-bottom: ${({ theme }) => theme.borders.primary};
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.textPrimary};
  width: ${({ width }) => (width ? width : '')};
  min-width: ${({ minWidth }) => (minWidth ? minWidth : 'initial')};
  white-space: nowrap;

  ${({ theme }) => theme.mediab.m580`
    font-size: ${rem(13)};
    line-height: ${rem(21)};
  `}
`;

export interface TableRowProps {
  clickable?: boolean;
}
export const TableRow: any = styled<TableRowProps, 'tr'>('tr')`
  cursor: ${props => (props.clickable ? 'pointer' : 'normal')};
  transition: all 0.1s ease-in-out;

  ${TableTh} {
    border-collapse: separate;
    border-spacing: 5px 5px;
    padding: 0;
  }

  ${TableTd} {
  }
`;

const DefaultTableTdWrapper = styled(TableTd)``;

const Content = styled(TextP)`
  font-size: ${rem(14)};
  line-height: ${rem(22)};
  margin-bottom: ${rem(12)};
  color: ${({ theme }) => theme.colors.primary};
  text-align: left;
  font-family: ${({ theme }) => theme.font.secondary};
  font-weight: 300;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: ${rem(200)};
`;

interface DefaultTableTdProps {
  text: string;
}

export function DefaultTableTd({ text }: DefaultTableTdProps) {
  return (
    <DefaultTableTdWrapper>
      <Content>{text}</Content>
    </DefaultTableTdWrapper>
  );
}
